"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHifiStorefrontPageView = void 0;
/**
 * A builder for HifiStorefrontPageView
 *
 * @param data - The event data
 * @return The formatted event data for HifiStorefrontPageViewEvent
 */
function createHifiStorefrontPageView(data) {
    return {
        name: 'HifiStorefrontPageView',
        environments: ['browser'],
        data: data,
    };
}
exports.createHifiStorefrontPageView = createHifiStorefrontPageView;
//# sourceMappingURL=createHifiStorefrontPageView.js.map